
import { Dealer } from './../../Models/Dealer';
import { Reducer, combineReducers } from 'redux';
import {
  DealerAction,
  CREATE_DEALER_SUCCESS,
  LOAD_DEALER_SUCCESS,
  LOAD_ALL_DEALER_GROUPS_SUCCESS,
  LOAD_ALL_DEALERS_SUCCESS,
  UPDATE_DEALER_SUCCESS,
  UPDATE_DEALER_GROUP_SUCCESS,
  CREATE_DEALER_GROUP_SUCCESS,
  ADD_DEALER_TO_DEALER_GROUP_SUCCESS,
  REMOVE_DEALER_FROM_DEALER_GROUP,
  REMOVE_DEALER_FROM_DEALER_GROUP_SUCCESS,
  UPDATE_DEALER_DEALER_GROUP_MEMBER_SUCCESS,
} from './actions';
import { DealerGroup } from '../../Models/DealerGroup';

export interface DealerState {
  dealers : Dealer[];
  dealerGroups: DealerGroup[];
}
const INITIAL_STATE: DealerState = {
  dealers : [],
  dealerGroups: [],
}
const dealersReducer = (state: Dealer[] = INITIAL_STATE.dealers, action: DealerAction): Dealer[] => {
  switch(action.type) {
    case LOAD_ALL_DEALERS_SUCCESS:
      return action.payload.dealers;
    case CREATE_DEALER_SUCCESS:
      return [...state, action.payload.dealer];
    case UPDATE_DEALER_SUCCESS:
      return state.map((dealer: Dealer) => {
        if (dealer.id === action.payload.dealer.id) {
          return action.payload.dealer;
        }
        return dealer;
      });
    case ADD_DEALER_TO_DEALER_GROUP_SUCCESS: {      
      return state.map((dealer: Dealer) => {
        if(action.payload.dealerDealerGroup.dealerId.toLowerCase() === dealer.id.toLowerCase()) {
          return {
            ...dealer,
            dealerGroupLookupInfoList: [...dealer.dealerGroupLookupInfoList, {
              dealerGroupId: action.payload.dealerDealerGroup.dealerGroupId,
              memberName: action.payload.dealerDealerGroup.memberName,
              memberNumber: action.payload.dealerDealerGroup.memberNumber
            }]
          };
        }
        return dealer;
      });
    }
    case REMOVE_DEALER_FROM_DEALER_GROUP_SUCCESS: {
      return state.map((dealer: Dealer) => {
        if(action.payload.dealerId.toLowerCase() === dealer.id.toLowerCase()) {
          return {
            ...dealer,
            dealerGroupLookupInfoList: dealer.dealerGroupLookupInfoList.filter(dgli => dgli.dealerGroupId.toLowerCase() !== action.payload.dealerGroupId.toLowerCase())
          };
        }
        return dealer;
      });
    }
    case UPDATE_DEALER_DEALER_GROUP_MEMBER_SUCCESS: {
      return state.map((dealer: Dealer) => {
        if(action.payload.dealerDealerGroup.dealerId.toLowerCase() === dealer.id.toLowerCase()) {
          return {
            ...dealer,
            dealerGroupLookupInfoList: dealer.dealerGroupLookupInfoList.map(dgli => {
              if(dgli.dealerGroupId.toLowerCase() === action.payload.dealerDealerGroup.dealerGroupId.toLowerCase()) {
                return {
                  ...dgli,
                  memberName: action.payload.dealerDealerGroup.memberName,
                  memberNumber: action.payload.dealerDealerGroup.memberNumber
                };
              }
              return dgli;
            })
          };
        }
        return dealer;
      });
    }
    
    default:
      return state;
  }
}
const dealerGroupsReducer = (state: DealerGroup[] = INITIAL_STATE.dealerGroups, action: DealerAction): DealerGroup[] => {
  switch(action.type) {
    case LOAD_ALL_DEALER_GROUPS_SUCCESS:
      return action.payload.dealerGroups;
    case UPDATE_DEALER_GROUP_SUCCESS:
      return state.map((dealerGroup: DealerGroup) => {
        if (dealerGroup.id?.toLowerCase() === action.payload.dealerGroup.id?.toLowerCase()) {
          return action.payload.dealerGroup;
        }
        return dealerGroup;
      });
    case CREATE_DEALER_GROUP_SUCCESS:
      return [...state, action.payload.dealerGroup];
    default:
      return state;
  }
}


export const dealerReducer: Reducer<DealerState> = combineReducers<DealerState>({
  dealers: dealersReducer,
  dealerGroups: dealerGroupsReducer
});
